import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
@Injectable({
  providedIn: 'root'
})
export class ConsultaService {

  constructor(private http: HttpClient, private authService: AuthService) { }
  private cod: any;
  //private url_base_svc = 'http://localhost:50008';
  private url_base_svc = 'https://corp-190-57-148-102.uio.puntonet.ec/svcagua';
  //private url_base_aq = 'http://186.4.141.215:8000';
  private url_base_aq = 'https://corp-190-12-6-204.uio.puntonet.ec/MarsedEpmapsweb';
  //headers: HttpHeaders = new HttpHeaders({
  //  "Content-Type": "application/json",
  //  Authorization: this.authService.getToken()
  //});

  EjecuratarServicioAguaGet(uri,parametro){
    return this.http.get(this.url_base_svc+uri + parametro).pipe(map(result => result));
  }
  /*DatosCliente(cedula): Observable<any> {
    return this.http.get(this.url_base_svc + '/api/lectura/' + cedula).pipe(map(result => result));

  }*/
  /*DatosClientes(): Observable<any> {
    return this.http.get(this.url_base_svc + '/api/lecturas').pipe(map(result => result));
  }
*/
  obtenerDatos(lectura): Observable<any> {
    return this.http.post(this.url_base_svc + '/MarsedEpmaps/Svc/OrdenLectura.svc/OrdenLecturaConsultarDetalle', lectura).pipe(map(result => result));
  }
 
  obtenerDatosCliente(lectura) {
    return this.http.post(this.url_base_svc + '/MarsedEpmaps/Svc/OrdenLectura.svc/InformacionAdicionalConsultar', lectura);
  }



  /*GrabarLectura(lectura) {
    return this.http.post(this.url_base_svc + '/api/lectura', lectura);
  }*/

/*  guardarFoto(foto): Observable<any> {
    return this.http.post(this.url_base_svc + '/api/foto', foto).pipe(map(result => result));
  }
*/
  /*guardarLecturaAguaQuito(lecturas) {
    return this.http.post(this.url_base_svc + '/api/aq_lectura', lecturas);
  }*/

  /*guardarInfoAdicionalAguaQuito(info) {
    return this.http.post(this.url_base_svc + '/api/aq_informacion_adicional', info);
  }*/


  /*registroUsuario(Usuario) {
    return this.http.post(this.url_base_svc + '/api/usuario/crear', Usuario);
  }*/


  /*ActualizarEstadoLec(lectura) {
    return this.http.post(this.url_base_svc + '/api/lectura/actualizar', lectura);
  }*/

  EjecutarServicioPost(uri ,parametro )
  {
   return this.http.post(this.url_base_svc + uri, parametro);
  }
  getCodigoLector() {
    return this.cod;
  }
  setCodigoLector(codigo) {
    localStorage.setItem("codlector", codigo);
    this.cod = codigo;
  }
  

  alertSpinner(){
    let timerInterval=Swal.fire({
      title: 'Cargando...!',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
        
      },
      willClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      console.log(result);
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log('I was closed by the timer')
      }
    })
   
  }
  closeSweet(){
    Swal.close();
  }


}
